import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

// Floating "Back to Top" pill — appears after scrolling down, uses the Lenis
// instance for a smooth glide, and mirrors the footer's hairline + lime style.
const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const toTop = () => {
        if (window.lenis) window.lenis.scrollTo(0, { duration: 1.4 });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.button
                    type="button"
                    onClick={toTop}
                    aria-label="Back to top"
                    data-testid="back-to-top"
                    data-cursor="hover"
                    initial={{ opacity: 0, y: 24, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 24, scale: 0.9 }}
                    transition={{ duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
                    className="group fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] flex items-center gap-2.5 rounded-full border border-[var(--line-2)] bg-[var(--surface)] pl-4 pr-2 py-2 shadow-[0_8px_30px_rgba(0,0,0,0.25)] transition-colors duration-300 hover:border-[var(--accent)]"
                >
                    <span className="font-mono-brand text-[10px] uppercase tracking-[0.24em] text-[var(--ink-3)] transition-colors duration-300 group-hover:text-[var(--ink)]">
                        Top
                    </span>
                    <span className="grid h-8 w-8 place-items-center rounded-full bg-[var(--accent)] text-[var(--accent-ink)] transition-transform duration-300 group-hover:-translate-y-0.5">
                        <ArrowUp className="h-4 w-4" strokeWidth={2.2} />
                    </span>
                </motion.button>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;
